<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><span class="epub-i">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title01" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/chapter1">Begin Reading</a></p>
<p class="toc"><span href="#/xhtml/adcard" title="Link target outside of Sample">Also by Walter Mosley</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?22038099